<template>
  <div class="examine-all">
    <el-dialog :title="title" align="center" :visible.sync="dialogVisible" width="90%" :close-on-click-modal="false" :before-close="handleClose">
      <div class="media-box" id="media-box">

      </div>
    </el-dialog>
  </div>
</template>
<script>
import videojs from 'video.js'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      title: '查看当前列表所有视频',
      dialogVisible: false,
      list: [],
      player: {
        player0: '',
        player1: '',
        player2: '',
        player3: '',
        player4: '',
        player5: '',
        player6: '',
        player7: '',
        player8: '',
        player9: ''
      }
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      document.getElementById("media-box").innerHTML = "";
      this.list.forEach((item, i) => {
        if (this.player['player' + i]) {
          this.player['player' + i].dispose()
        }
      })
    },
    open(list) {
      this.list = [];
      this.dialogVisible = true;
      this.list = list;
      this.$nextTick(function () {
        list.forEach((item, i) => {
          let mediaUrl = baseConfig.baseServerUrl + baseConfig.playVideoUrl + item.url + '?token=' + this.token
          document.getElementById("media-box").innerHTML += '<div class="video-box"><div class="title">' + (item.title || '未知') + '</div><video id="my-video' + i + '" class="video-js vjs-default-skin" controls preload="auto"></video></div>'
          let self = this
          setTimeout(function () {
            self.player['player' + i] = videojs('my-video' + i, {
              bigPlayButton: false,
              textTrackDisplay: false,
              posterImage: true,
              errorDisplay: true,
              controlBar: true
            }, function () {
              this.play()
            })
            self.player['player' + i].src(mediaUrl)
          })
        });
      })

    }
  }
}
</script>
<style lang="scss">
.examine-all {
  .media-box {
    width: 100%;
    height: 100%;
  }
  .el-dialog {
    margin-top: 70px !important;
  }
  .el-dialog__body {
    overflow: hidden;
  }
  .video-box {
    width: 19%;
    float: left;
    height: 330px;
    margin-left: 1%;
    margin-bottom: 30px;
    .video-js {
      width: 100%;
      height: 100%;
    }
    .title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      white-space: nowrap; /* 不换行 */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>